import React,{useState, useEffect}  from 'react';

import Sides from '../Bars/Jssidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Csmethod(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  
return(
    <div>
      <Sides/>
  
      <Helmet>
 
 <title>Learn Free JavaScript Function Tutorials For Beginners CodeExampler</title>
 <meta name="description" content="Javascript Method tutorial for beginners.The Javascript methods contain one more statement and each method performs only one task, CodeExampler provides Multiple Programming Examples for Beginners,CodeExampler provides Free Online Tutorials for beginners" />
 <meta name="keywords" content="codeexampler,tutorial for begineers,Javascript Method,Javascript foreach function,Method call in Javascript,javascript function map,javascript function call,javascript function callback,javascript function declaration,javascript is function defined,javascript function with parameter,javascript function parameters,javascript function constructor,javascript function as parameter,javascript functional programming,javascript function arguments,javascript function syntax,javascript function object" />
 <link rel="canonical" href="https://www.codeexampler.com/javascript-function" />
 </Helmet>

 <div className='lg:pl-56'>
    <h1 className="m-4 mh1">Javascript Function</h1>
    <div className="first">
        <a href="/javascript-continue">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/javascript-user-define-function">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    <p className="mt-4 para">The Javascript Function contains one more statement, and each method performs only one task.
        <br/>
        Each method gives a name, and after this name is used to call the method.
    </p>


<h2 className="headings">Methods in Javascript Syntax:</h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
        {"\n"}
          <span className="qwerty-6">Method </span>
          <span className="qwerty-8">name </span>
          <span className="qwerty-3">( </span>
          <span className="qwerty-4">parenthesis </span>
          <span className="qwerty">or </span>
          <span className="qwerty-4">parameter-list </span>
          <span className="qwerty-3">) </span>
          {"\n"}
          <span className="qwerty-3">&#123; </span>
  {"\n"}
          <span className="qwerty-10">&nbsp;//body of a method </span>          
          {"\n"}
          <span className="qwerty-3">&#125; </span>
          {"\n"} {"\n"}
    
       
        </code>
      </pre>        
    </div>




<h2 className="headings">Q-Write a Program use one method in Javascript?</h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
        {"\n"}
        <span className="qwerty-3">&#60;/</span>
<span className="qwerty-8">script</span>
          <span className="qwerty-3">&#62; </span>
           
  {"\n"}
  <span className="qwerty-6">&nbsp;&nbsp;function </span>
  <span className="qwerty-10">teachers</span>
  <span className="qwerty-1">(</span>
        <span className="qwerty-1">)</span>
  {"\n"}

  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#123; </span>
  {"\n"}
 

  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;document</span>
      <span className="qwerty">.</span>
      <span className="qwerty-2">write</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-3">"</span> 
        <span className="qwerty-8">teaching</span> 
        <span className="qwerty-3">"</span> 
      <span className="qwerty-1">);</span>
      {"\n"}
  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#125; </span>
  {"\n"}
 

  <span className="qwerty-2">&nbsp;&nbsp;document</span>
      <span className="qwerty">.</span>
      <span className="qwerty-2">write</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-3">"</span> 
        <span className="qwerty-8">Start method</span> 
        <span className="qwerty-3">"</span> 

      <span className="qwerty-1">);</span>
      {"\n"}
      <span className="qwerty-10">&nbsp;&nbsp;teachers</span>
  <span className="qwerty-1">(</span>
        <span className="qwerty-1">)</span>
        {"\n"}

<span className="qwerty-3">&#60;/</span>
<span className="qwerty-8">script</span>
          <span className="qwerty-3">&#62; </span>
            {"\n"} {"\n"}
    </code>
      </pre>        
    </div>
    
    
    
    <div>
      <h3 className="headings">Output</h3>
      <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">
          {"\n"}
          <span className="qwerty-5">&nbsp;start method </span>          
          {"\n"}
          <span className="qwerty-10">&nbsp;teaching </span>          
          {"\n"}
            </code>{"   "}
            </pre>
      </div>
    </div>




<h2 className="headings">Q-Write a Program Use two methods and create different objects for different methods in Javascript?</h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
        {"\n"}
        <span className="qwerty-3">&#60;/</span>
<span className="qwerty-8">script</span>
          <span className="qwerty-3">&#62; </span>
           
  {"\n"}
  <span className="qwerty-6">&nbsp;&nbsp;function </span>
  <span className="qwerty-10">Code</span>
  <span className="qwerty-1">(</span>
        <span className="qwerty-1">)</span>
  {"\n"}

  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#123; </span>
  {"\n"}
 

  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;document</span>
      <span className="qwerty">.</span>
      <span className="qwerty-2">write</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-3">"</span> 
        <span className="qwerty-8">CodeExampler</span> 
        <span className="qwerty-3">"</span> 
 
      <span className="qwerty-1">);</span>
      {"\n"}
  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#125; </span>
      {"\n"}
  <span className="qwerty-6">&nbsp;&nbsp;function </span>
  <span className="qwerty-3">Ram</span>
  <span className="qwerty-1">(</span>
        <span className="qwerty-1">)</span>
  {"\n"}

  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#123; </span>
  {"\n"}
 

  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;document</span>
      <span className="qwerty">.</span>
      <span className="qwerty-2">write</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-3">"</span> 
        <span className="qwerty-8">Hello Ram</span> 
        <span className="qwerty-3">"</span> 

      <span className="qwerty-1">);</span>
      {"\n"}
  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#125; </span>
      {"\n"}{"\n"}
      <span className="qwerty-10">&nbsp;&nbsp;Code</span>
  <span className="qwerty-1">(</span>
        <span className="qwerty-1">)</span>
        {"\n"}
      <span className="qwerty-10">&nbsp;&nbsp;Ram</span>
  <span className="qwerty-1">(</span>
        <span className="qwerty-1">)</span>
        {"\n"}
      <span className="qwerty-10">&nbsp;&nbsp;Code</span>
  <span className="qwerty-1">(</span>
        <span className="qwerty-1">)</span>
        {"\n"}
      <span className="qwerty-10">&nbsp;&nbsp;Code</span>
  <span className="qwerty-1">(</span>
        <span className="qwerty-1">)</span>
        {"\n"}
      <span className="qwerty-10">&nbsp;&nbsp;Code</span>
  <span className="qwerty-1">(</span>
        <span className="qwerty-1">)</span>
        {"\n"}

<span className="qwerty-3">&#60;/</span>
<span className="qwerty-8">script</span>
          <span className="qwerty-3">&#62; </span>
            {"\n"}   {"\n"}
    </code>
      </pre>        
    </div>
    
    
    
    <div>
      <h3 className="headings">Output</h3>
      <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">
          {"\n"}
          <span className="qwerty-3">&nbsp;CodeExampler </span>          
          {"\n"}
          <span className="qwerty-10">&nbsp;Hello Ram </span>          
          {"\n"}
          <span className="qwerty-3">&nbsp;CodeExampler </span>          
          {"\n"}
          <span className="qwerty-3">&nbsp;CodeExampler </span>          
          {"\n"}
          <span className="qwerty-3">&nbsp;CodeExampler </span>          
          {"\n"}
            </code>{"   "}
            </pre>
      </div>
    </div>



<h2 className="headings">Q-Write a Program Use two methods and create different objects for different methods in Javascript?</h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
        {"\n"}
        <span className="qwerty-3">&#60;/</span>
<span className="qwerty-8">script</span>
          <span className="qwerty-3">&#62; </span>
           
  {"\n"}
  <span className="qwerty-6">&nbsp;&nbsp;function </span>
  <span className="qwerty-10">teachers</span>
  <span className="qwerty-1">(</span>
        <span className="qwerty-1">)</span>
  {"\n"}

  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#123; </span>
  {"\n"}
 

  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;document</span>
      <span className="qwerty">.</span>
      <span className="qwerty-2">write</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-3">"</span> 
        <span className="qwerty-8">Teaching</span> 
        <span className="qwerty-3">"</span> 
     
      <span className="qwerty-1">);</span>
      {"\n"}
  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#125; </span>
      {"\n"}
  <span className="qwerty-6">&nbsp;&nbsp;function </span>
  <span className="qwerty-3">students</span>
  <span className="qwerty-1">(</span>
        <span className="qwerty-1">)</span>
  {"\n"}

  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#123; </span>
  {"\n"}
 

  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;document</span>
      <span className="qwerty">.</span>
      <span className="qwerty-2">write</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-3">"</span> 
        <span className="qwerty-8">Learn</span> 
        <span className="qwerty-3">"</span> 
   
      <span className="qwerty-1">);</span>
      {"\n"}
  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#125; </span>
      {"\n"}
      {"\n"}
 

  <span className="qwerty-2">&nbsp;&nbsp;document</span>
      <span className="qwerty">.</span>
      <span className="qwerty-2">write</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-3">"</span> 
        <span className="qwerty-8">Start Class</span> 
        <span className="qwerty-3">"</span> 
  
      <span className="qwerty-1">);</span>
      {"\n"}
      {"\n"}
      <span className="qwerty-10">&nbsp;&nbsp;teachers</span>
  <span className="qwerty-1">(</span>
        <span className="qwerty-1">)</span>
        {"\n"}
      <span className="qwerty-3">&nbsp;&nbsp;students</span>
  <span className="qwerty-1">(</span>
        <span className="qwerty-1">)</span>
        {"\n"}

<span className="qwerty-3">&#60;/</span>
<span className="qwerty-8">script</span>
          <span className="qwerty-3">&#62; </span>
            {"\n"}{"\n"}
    </code>
      </pre>        
    </div>
    
    
    
    <div>
      <h3 className="headings">Output</h3>
      <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">
          {"\n"}
          <span className="qwerty-3">&nbsp;Start Class </span>          
          {"\n"}
          <span className="qwerty-8">&nbsp;Teaching </span>          
          {"\n"}
          <span className="qwerty-10">&nbsp;Learn </span>          
          {"\n"} 
            </code>{"   "}
            </pre>
      </div>
    </div>


<h2 className="mt-4 mh2">Important:</h2>
<p className="mt-4 para">You create multiple objects you do, but programming run speed decreases, creating fewer objects to gain high speed.
</p>



<h2 className="headings">Q-Write a Program uses a different class on Javascript Method Example?</h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
        {"\n"}
        <span className="qwerty-3">&#60;/</span>
<span className="qwerty-8">script</span>
          <span className="qwerty-3">&#62; </span>
           
  {"\n"}
  <span className="qwerty-6">&nbsp;&nbsp;function </span>
  <span className="qwerty-10">teachers</span>
  <span className="qwerty-1">(</span>
        <span className="qwerty-1">)</span>
  {"\n"}

  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#123; </span>
  {"\n"}
 

  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;document</span>
      <span className="qwerty">.</span>
      <span className="qwerty-2">write</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-3">"</span> 
        <span className="qwerty-8">Teaching</span> 
        <span className="qwerty-3">"</span> 
  
      <span className="qwerty-1">);</span>
      {"\n"}
  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#125; </span>
      {"\n"}
  <span className="qwerty-6">&nbsp;&nbsp;function </span>
  <span className="qwerty-3">students</span>
  <span className="qwerty-1">(</span>
        <span className="qwerty-1">)</span>
  {"\n"}

  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#123; </span>
  {"\n"}
 

  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;document</span>
      <span className="qwerty">.</span>
      <span className="qwerty-2">write</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-3">"</span> 
        <span className="qwerty-8">Learn</span> 
        <span className="qwerty-3">"</span> 
 
      <span className="qwerty-1">);</span>
      {"\n"}
  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#125; </span>
      {"\n"}
      {"\n"}
 

  <span className="qwerty-2">&nbsp;&nbsp;document</span>
      <span className="qwerty">.</span>
      <span className="qwerty-2">write</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-3">"</span> 
        <span className="qwerty-8">Start Class</span> 
        <span className="qwerty-3">"</span> 
   
      <span className="qwerty-1">);</span>
      {"\n"}
      {"\n"}
      <span className="qwerty-10">&nbsp;&nbsp;teachers</span>
  <span className="qwerty-1">(</span>
        <span className="qwerty-1">)</span>
        {"\n"}
      <span className="qwerty-3">&nbsp;&nbsp;students</span>
  <span className="qwerty-1">(</span>
        <span className="qwerty-1">)</span>
        {"\n"}
      <span className="qwerty-7">&nbsp;&nbsp;Peon</span>
  <span className="qwerty-1">(</span>
        <span className="qwerty-1">)</span>
        {"\n"}
        {"\n"}
  <span className="qwerty-6">&nbsp;&nbsp;function </span>
  <span className="qwerty-7">Peon</span>
  <span className="qwerty-1">(</span>
        <span className="qwerty-1">)</span>
  {"\n"}

  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#123; </span>
  {"\n"}
 

  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;document</span>
      <span className="qwerty">.</span>
      <span className="qwerty-2">write</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-3">"</span> 
        <span className="qwerty-8">Learn</span> 
        <span className="qwerty-3">"</span> 
        <span className="qwerty">+</span> 
        <span className="qwerty-3">&#60;</span> 
        <span className="qwerty-4">br/</span> 
        <span className="qwerty-3">&#62;</span> 
        <span className="qwerty-3">"</span>
      <span className="qwerty-1">);</span>
      {"\n"}
  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#125; </span>
      {"\n"}
<span className="qwerty-3">&#60;/</span>
<span className="qwerty-8">script</span>
          <span className="qwerty-3">&#62; </span>
            {"\n"}   {"\n"}
      </code>
      </pre>        
    </div>
    
    
    
    <div>
      <h3 className="headings">Output</h3>
      <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">
          {"\n"}
          <span className="qwerty-3">&nbsp;Start Class </span>          
          {"\n"}
          <span className="qwerty-10">&nbsp;Teaching </span>          
          {"\n"}
          <span className="qwerty-5">&nbsp;Learn </span>          
          {"\n"}
          <span className="qwerty-7">&nbsp;Ring the bell </span>          
          {"\n"}
            </code>{"   "}
            </pre>
      </div>
    </div>

  <h1 className="mt-5">  </h1>
  <div className="back">
        <a href="/javascript-continue">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/javascript-user-define-function">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
        </div>

    </div>
)

}
export default Csmethod;